export const googleIceServers = [
  {
    urls: [
      "stun:stun.l.google.com:19302",
      "stun:stun1.l.google.com:19302",
      "stun:stun2.l.google.com:19302",
      "stun:stun3.l.google.com:19302",
      "stun:stun4.l.google.com:19302"
    ]
  }
];

export const rcIceServers = [
  {
    urls: 'stun:159.89.4.1:3478'
  },
  {
    urls: 'turn:159.89.4.1:3478',
    username: "bagless",
    credential: "11Vh0vvHVj6LObpjnSXyGU%K1za7N1",
  }
];
export const productionIceServers = [
  {
    urls: 'stun:165.227.128.104:3478'
  },
  {
    urls: 'turn:165.227.128.104:3478',
    username: "bagless",
    credential: "11Vh0vvHVj6LObpjnSXyGU%K1za7N1",
  }
];

